import React from "react";
import { PageLayout } from "../components/PageLayout";
import { PlanBuilder } from "../features/plans/PlanBuilder";

export const CreateYourPlanPage: React.FC = () => {
  return <PageLayout>
    <PlanBuilder />
  </PageLayout>;
};